/**
 * São Tomé and Príncipe dobra.
 */
export var STN = {
  code: 'STN',
  base: 10,
  exponent: 2
};